import WarehouseCURModule from "@/modules/WarehouseCUR";

function ViewWarehousePage() {
  return <WarehouseCURModule type="view" />;
}

export default ViewWarehousePage;
